export default (from, to, as = 'minute', onlyPositive = false) => {
  if (!from || !to) { return 0 }
  const value = dayjs(from).diff(dayjs(to), as);
  if (!onlyPositive) { return value }

  return value < 0 ? 0 : value;
};
